<template>
  <div :class="{ 'root-comment': true, 'with-subcomments': comment.children && comment.children.length > 0 }">
    <comment
      :comment="comment"
      :display-participant-tags="displayParticipantTags"
    />
    <div
      v-if="comment.children"
      class="sub-comments"
    >
      <comment
        v-for="subcomment in comment.children"
        :key="subcomment.identifier"
        :comment="subcomment"
        :display-participant-tags="!isParticipant"
      />
    </div>
  </div>
</template>

<script>
import Comment from '../interactions/Comment.vue'

export default {
  name: 'RootComment',
  components: {
    Comment
  },
  props: {
    comment: {
      type: Object,
      default: null
    },
    displayParticipantTags: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.root-comment.with-subcomments {
  & > div.message-format-container:first-child {
    border-bottom-width: 1px;
  }
}

.sub-comments {
  padding-left: 60px;

  .comment-container {
    position: relative;

    &:first-child {
      border-top-color: rgba(0, 0, 0, 0);
    }

    &:before {
      content: "";
      width: 2px;
      height: 39px;
      background: $gray-light;
      position: absolute;
      left: -28px;
      top: -1px;
    }

    &:after {
      content: "";
      width: 27px;
      height: 2px;
      background: $gray-light;
      position: absolute;
      left: -28px;
      top: 38px;
    }

    &:not(:last-child) {
      &:before {
        height: calc(100% + 1px);
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  @media (max-width: 400px) {
    padding-left: 22px;

    .comment-container {
      &:before {
        left: -9px;
      }
      &:after {
        left: -9px;
        width: 15px;
      }
    }
  }
}
</style>
